import React from "react";
import { hairProblems } from "../mock";
import { ArrowRight } from "lucide-react";

export default function HairProblems() {
  return (
    <section className="section bg-[#F5EFE6]">
      <div className="container-y">
        <div className="text-center mb-12 md:mb-16">
          <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
            Personalized care
          </p>
          <h2 className="font-serif-y text-3xl md:text-5xl text-[#1a1a1a] max-w-3xl mx-auto">
            What&rsquo;s Standing Between You and Great Hair?
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
          {hairProblems.map((h) => (
            <a
              key={h.title}
              href={h.href}
              target="_blank"
              rel="noreferrer"
              className="group flex flex-col items-center text-center"
            >
              <div className="w-full aspect-square bg-white overflow-hidden mb-5">
                <img
                  src={h.img}
                  alt={h.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <h3 className="font-serif-y text-lg md:text-xl text-[#1a1a1a] group-hover:text-[#C9A961] transition-colors inline-flex items-center gap-2">
                {h.title}
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
